import PropTypes from 'prop-types'
import { Typography, Alert, Button, IconButton } from '@mui/material'

import * as routes from '../../../routes'
import { NavLink } from 'react-router-dom'

import useTranslations from '../../../i18n/useTranslations'

import { ReactComponent as X } from '../../../assets/icons/x.svg'

import useStyles from './styles'

const PrintDownloadAlertView = ({ closeAlert }) => {
  const t = useTranslations()
  const classes = useStyles()

  const handleCloseClick = ev => {
    closeAlert()
  }
  return (
    <Alert severity="info" className={classes.root}>
      <IconButton
        size="medium"
        onClick={handleCloseClick}
        className={classes.closeButton}
      >
        <X />
      </IconButton>
      <Typography component="p" variant="h4" className={classes.alertTitle}>
        {t('print-alert:title')}
      </Typography>

      <Typography component="p" variant="body2">
        {t('print-alert:description')}
      </Typography>

      <Button
        component={NavLink}
        size="small"
        to={routes.DOWNLOADS.path}
        onClick={handleCloseClick}
        className={classes.downloadButton}
      >
        <Typography component="span" variant="h4">
          {t('print-alert:i-want-know-more')}
        </Typography>
      </Button>
    </Alert>
  )
}

PrintDownloadAlertView.propTypes = {
  closeAlert: PropTypes.func.isRequired,
}

export default PrintDownloadAlertView
